export const getAll = state => state.clubs.data